<template>
  <div>

    <Breadcrumbs 
      :children="[
        {
          text: 'Zonas de disponibilidad',
        }
      ]"/>

    <div class="card ml-15">
      <div class="card-body">

        <div v-if="loading" class="text-center">
          <Loader />
        </div>
        <div v-else class="table-wraper">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>Provincia</th>
                <th>Foto</th>
                <th class="text-center">Activa ({{ activeProvincesCount }})</th>
                <th class="text-center">Optiones</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="item in provinces" :key="item.id">
                <td>{{ item.name }}</td>
                <td>
                  <img :src="item.photo || '/logo_blue.png'" :alt="item.name">
                </td>
                <td class="text-center">{{ item.available ? 'Si' : 'No' }}</td>
                <td class="text-center">
                  <i v-if="item.loading" class="fa fa-spinner fa-spin"></i>
                  <a v-else href="#" class="btn btn-sm main-bg text-white" @click.prevent="openZones(item)">
                    Ver zonas
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- MODAL -->
    <div class="modal fade" 
      id="zones-modal" 
      tabindex="-1"
      role="dialog"
      aria-labelledby="zones-modal-header"
      aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">

        <div class="modal-content">

          <div class="modal-header">
            <h4 style="margin:0;" id="zones-modal-header">Zonas de <b>{{ openedProvince.name }}</b></h4>
          </div>
          <div class="modal-body">

            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <input ref="name" type="text" v-model="newZone" placeholder="Nombre zona" class="form-control">
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <input ref="lat" type="text" v-model="lat" placeholder="Latitude" class="form-control">
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <input ref="lng" type="text" v-model="lng" placeholder="Longitude" class="form-control">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 text-right">
                <button :disabled="saving" @click="addZone" class="btn main-bg text-white">Guardar</button>
              </div>
            </div>

            <ul class="list-group">
              <li class="list-group-item" v-for="z in zones" :key="z.id">
                <div class="row">
                  <div class="col-sm-5 col-10 text-left">{{ z.name }}</div>
                  <div class="col-sm-5 col-10 text-left">{{ z.latitude }}, {{ z.longitude }}</div>
                  <div class="col-sm-2 col-2 text-right">
                    <a href="#" @click="dropZone(z)"><i class="fa fa-close text-danger fa-2x"></i></a>
                  </div>
                </div>
              </li>
            </ul>

          </div>
          <div class="modal-footer">
            <a href="#" @click="closeModal" class="text-dark p-2">Cerrar</a>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import { UtilsService } from '../../services/UtilsService'
export default {
  name: 'ProvinceZones',
  components: { Breadcrumbs,Loader },
  data:function(){
    return {
      provinces: [],
      zones: [],
      loading: false,
      saving: false,
      openedProvince: {
        id: '',
        name: ''
      },
      newZone: '',
      lat: '',
      lng: '',
      utilsService: new UtilsService()
    }
  },
  methods: {
    async addZone(){
      if(!this.newZone.trim()){
        this.$helpers.toast('El nombre es requerido', 'warning');
        this.$refs.name.focus();
        return;
      }
      if(!this.lat){
        this.$helpers.toast('La latitud es requerida', 'warning');
        this.$refs.lat.focus();
        return;
      }
      if(!this.lng){
        this.$helpers.toast('La longitud es requerida', 'warning');
        this.$refs.lng.focus();
        return;
      }
      this.saving = true;
      const newZoneName = this.newZone.trim();
      const doc = await this.utilsService.addZone(
        this.openedProvince.id, 
        newZoneName,
        this.lat,
        this.lng
      );
      if(doc.ok){
        this.zones.push(doc.data);
        this.newZone = '';
        this.lat = '';
        this.lng = '';
      }else{
        this.$helpers.message('Error', doc.message, 'error');
      }
      this.saving = false;
    },
    async dropZone(zone){
      const ok = await this.$helpers.confirm('La zona sera eliminada');
      if(!ok){
        return;
      }
      try {        
        await this.utilsService.dropZone(this.openedProvince.id, zone.id);
        this.$helpers.toast('Zona eliminada', 'success');
        this.zones.splice(
          this.zones.findIndex(x => x.id === zone.id),
          1
        );
      } catch (error) {
        console.log(error);
        this.$helpers.message('Oops', 'Error al eliminar', 'error');        
      }
    },
    closeModal(){
      $('#zones-modal').modal('hide');
      this.zones = [];
      this.openedProvince = {
        id: '',
        name: ''
      };
      this.newZone = '';
    },
    async openZones(province){
      province.loading = true;
      this.openedProvince = {
        name: province.name,
        id: province.id
      };
      const res = await this.utilsService.getZonesByProvince(province.id);
      if(res.ok){
        this.zones = res.data;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      province.loading = false;
      $('#zones-modal').modal('show');
    },
    async getProvinces(){
      this.loading = true;
      const res = await this.utilsService.getProvinces();
      if(res.ok){
        this.provinces = res.data;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
  },
  beforeMount: function() {
    this.getProvinces();
  },
  computed: {
    activeProvincesCount(){
      return this.provinces.filter(x => x.available).length;
    }
  }
}
</script>

<style scoped>
tbody td{
  font-weight: 400;
}
.table-wraper{
  overflow-y: auto;
  max-height: 60vh;
}
img{
  height: 50px;
  width: auto;
}
</style>